import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  OnChanges,
} from "@angular/core";
import { AlertService } from "../../../services";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";

import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute } from "@angular/router";
import { AutoUnsubscribe } from "../../../store";
import { CampaignService } from "../../../services/campaign.service";

@Component({
  selector: "app-sendgrid-communication-campaign-flyout",
  templateUrl: "./communication-campaign-flyout.component.html",
  styleUrls: ["./communication-campaign-flyout.component.css"],
})

@AutoUnsubscribe
export class CommunicationCampaignFlyoutComponent implements OnInit, OnChanges {
  @Input() isCreateNewCampaingActive: boolean;
  @Input() allTemplates
  @Output() close = new EventEmitter();
  @Output() createCampaign: EventEmitter<any> = new EventEmitter();

  //campaign payload
  birthYears = [];
  campaignName = "";
  subject = "";
  from = "";

  payload = {

    //Essentials
    emailSubject: '',
    campaignName: '',
    fromEmail: '',

    //Filtering
    sendingCampaignTo: "",
    //sendingCampaignTo = 'TEAM'
    selectedTeamIds: [],
    selectedTeamRoleIds: [],

    //sendingCampaignTo = 'TEAM'
    selectedStaffRoleIds: [],

    //sendingCampaignTo = 'PLAYER'
    playerGender: "b",
    playerCommitmentStatus: "-1",
    playerBirthYears: [],

    //template
    templateId: '',
    senderName: ''
  };

  //sendingCampaignTo = Team
  // 1. Select Team(s)
  public allClubTeams = [];
  public teamFields: Object = { text: "teamName", value: "teamId" };
  public mode: string;
  public placeholder = "Choose One Or Multiple";
  public isChange: boolean = false;

  // 2. Who Are You Sending To:
  sendEmailToTeamList = [
    // {name: 'All Staff', roleId: 0, checked:false},
    { name: "Head Coach", roleId: 3, checked: false },
    { name: "Assitant Coaches", roleId: 4, checked: false },
    { name: "Team Admins", roleId: 7, checked: false },
    { name: "Players", roleId: 1, checked: false },
    { name: "Parent", roleId: 2, checked: false }
  ];

  //sendingCampaignTo = Staff
  sendEmailToStaffList = [
    { name: "Executive Directors", roleId: 25, checked: false },
    { name: "Director of Coaching", roleId: 26, checked: false },
    { name: "College Recruiter", roleId: 18, checked: false },
    // {name: 'Age Coordinators', checked:false}, //todo - add role id
    { name: "Club Registrars", roleId: 17, checked: false },
    { name: "Program Admins", roleId: 30, checked: false },
    { name: "Club Treasures", roleId: 23, checked: false },
    { name: "Head Coaches", roleId: 3, checked: false },
    { name: "Assistant Coaches", roleId: 4, checked: false },
    { name: "Team Admins", roleId: 7, checked: false },
  ];

  playerCommitmentStatus: "";


  public clubId: number;
  constructor(
    private spinner: Ng4LoadingSpinnerService,
    private as: AlertService,
    private activeRoute: ActivatedRoute,
    private ds: DomSanitizer,
    private _campaignService: CampaignService,
  ) {
    this.mode = "CheckBox";

    for (let i = 0; i < 15; i++) {
      this.birthYears.push({ year: 2000 + i, checked: false });
    }

    this.resetNewCampaignFormPayload();

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.isCreateNewCampaingActive == true) {
      this.resetNewCampaignFormPayload();
      this.clubId = +localStorage.getItem("clubId");
      this.getClubTeamsByClubId(this.clubId);
    }
  }

  ngOnInit(): void {
    // this.mode = "CheckBox";
  }

  onTeamSelected(event: any) {
    this.payload.selectedTeamIds.push(event.itemData.teamId);
  }

  onTeamRemoved(item: any) {
    const index = this.payload.selectedTeamIds.indexOf(item.itemData.teamId);
    if (index !== -1) {
      this.payload.selectedTeamIds.splice(index, 1);
    }
  }

  onSelectAll(items: any) {
    this.payload.selectedTeamIds = [];
  }

  onTeamSendingToSelected(roleId, event) {
    this.payload.selectedTeamRoleIds = this.sendEmailToTeamList
      .filter((opt) => opt["checked"])
      .map((opt) => opt.roleId);
  }

  onStaffSendingToSelected(roleId, event) {
    this.payload.selectedStaffRoleIds = this.sendEmailToStaffList
      .filter((opt) => opt["checked"])
      .map((opt) => opt.roleId);
  }

  onPlayerBirthYearsChecked(event) {
    this.payload.playerBirthYears = this.birthYears
      .filter((opt) => opt["checked"])
      .map((opt) => opt.year);
  }

  getClubTeamsByClubId(clubId: number) {
    this._campaignService.getClubTeamsByClubId(clubId).subscribe(
      (result) => {
        this.allClubTeams = result;
      },
      (error) => {
        this.allClubTeams = [];
      }
    );
  }

  sendingToChanged(event = null) {
    if (this.payload.sendingCampaignTo == "Team") {
      this.sendEmailToTeamList.map((opt) => { opt.checked = true; });
      this.payload.selectedTeamRoleIds = this.sendEmailToTeamList
        .filter((opt) => opt["checked"])
        .map((opt) => opt.roleId);

    } else if (this.payload.sendingCampaignTo == "Staff") {

      this.sendEmailToStaffList.map((opt) => {
        opt.checked = true;
      });

      this.payload.selectedStaffRoleIds = this.sendEmailToStaffList
        .filter((opt) => opt["checked"])
        .map((opt) => opt.roleId);


    } else if (this.payload.sendingCampaignTo == "Players") {

      this.birthYears.map((opt) => {
        opt.checked = true;
      });

      this.payload.playerBirthYears = this.birthYears
        .filter((opt) => opt["checked"])
        .map((opt) => opt.year);
    }
    else {
    }

  }
  isEmailInvalid: boolean = false;
  onCreateCampaign(event) {
    if (!this.validateEmail(this.payload.fromEmail)) {
      this.isEmailInvalid = true;
      this.as.warn("Please Enter Valid Email Address");
      return;
    }
    this.createCampaign.emit(this.payload);
  }

  validateEmail(email) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }
  onCancel(event) {
    this.close.emit();
  }

  resetNewCampaignFormPayload() {
    this.payload.emailSubject = "";
    this.payload.campaignName = "";
    this.payload.fromEmail = "";
    this.payload.sendingCampaignTo = "";
    this.payload.selectedTeamIds = [];
    this.payload.selectedTeamRoleIds = [];
    this.payload.templateId = "";
    this.payload.selectedStaffRoleIds = [];
    this.payload.playerGender = "b";
    this.payload.playerCommitmentStatus = "-1";
    this.payload.playerBirthYears = [];
    this.payload.senderName = "";
  }

  get isValid(): boolean {
    if (this.payload.campaignName == "" ||
      this.payload.emailSubject == "" ||
      this.payload.senderName == "" ||
      this.payload.fromEmail == "" ||
      this.payload.sendingCampaignTo == "" ||
      this.payload.templateId == "") {
      return false;
    } else if (this.payload.sendingCampaignTo == "Team") {
      if (this.payload.selectedTeamIds.length == 0 || this.payload.selectedTeamRoleIds.length == 0) {
        return false;
      } else {
        return true;
      }
    } else if (this.payload.sendingCampaignTo == "Staff" && this.payload.selectedStaffRoleIds.length == 0) {
      return false;
    } else if (this.payload.sendingCampaignTo == "Players" && this.payload.playerBirthYears.length == 0) {
      return false;
    } else {
      return true;
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/pages/sendgrid/communication-campaign-flyout/communication-campaign-flyout.component.ts